const PublicRoutes = [
  '/cadastro',
  '/cadastro_novo',
  '/usuarios/password/new',
  '/signup=new',
  '/minhas_licitacoes/shares',
  '/usuarios/recurso_expirado',
  '/usuarios/invitation/accept',
  '/usuarios/password/edit',
  '/onboarding',
  '/register/pending-approval',
  '/register/preparing',
  '/conlicitaseg/cadastro',
  '/conlicitaseg/validar-email',
];

export default PublicRoutes;
